import React, { useEffect, useState } from "react";
import { DistributionsIntroduction,DistributionsRecommendations } from "../types";
import {getDistributionIntroduction,getDistributionRecommendations, getDistributionFollows} from "../../service";
import { useLoading } from "../../components/loading/LoadingProvider";
import { useHistory } from "react-router-dom";
import { useModal } from "../../components/modal";
import title from '../../images/fx-title.png';
import btn from '../../images/fx-page2-btn2.png';
import rules from '../../images/rules.png';
import useUserInfo from "../../routers/useUserInfo";
import usePagination from "../../routers/usePagination";
import Pagination from "../../components/pagination";
import {dateFormat} from "../../units";

const classnames = require('classnames')

function getStatusCodeText(index:number){
    return ['等待跟进','已经跟进','暂无意向','已付定金','已退定金','填报课程'][index]
}

function DistributionLists() {
    const [info, setInfo] = useState<DistributionsIntroduction>();
    // const [selected, setSelected] = useState<number>(0);
    const [cover,setCover] = useState(false)
    const [lists,setLists] = useState<Array<DistributionsRecommendations>>([])
    const loading = useLoading()
    const modal = useModal()
    const userData = useUserInfo();
    const { push, goBack } = useHistory()
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore,reset } = usePagination();


    useEffect(() => {
        loading.showLoading()
        getDistributionIntroduction()
            .then(res => {
                // console.log(res.data)
                setInfo(res.data)
                loading.hideLoading()
            }).catch(e => {
            loading.hideLoading()
            modal.show({
                title:'错误提示',
                content:'无法获取数据',
                showCancel:false,
                success(){
                    goBack()
                }
            })
        })
    },[])

    useEffect(() => {
        if(userData){
            getDistributionRecommendations({
                customerId:userData.id,
                pageNum
            }).then(res => {
                const lists = res.data.list
                if(lists.length > 0){
                    setLists(list => list.concat(lists))
                }else{
                    noMore()
                }
            })
        }
    },[pageNum])

    const handleClick = (id:string,index:number) => {

        if(lists[index].detail) return;

        getDistributionFollows({
            recordId:id,
            pageNum:1
        }).then(res => {
            if(res.code === 1){
                const _lists = [...lists]
                _lists[index].detail = res.data.list
                setLists(_lists)
            }else{
                modal.show({
                    title:'错误提示',
                    content:res.msg,
                    showCancel:false,
                    success(){

                    }
                })
            }
        })
    }


    const handleCancel = () => {
        setCover(false)
    }


    // console.log(lists)

    return <div className="Distribution distributionDetail distributionLists">
        <img src={ title } alt="" className="title"/>

        <div className="box2">
            <img src={ rules } onClick={() => setCover(true)} className='rules-icon' alt=""/>
            <div className="wrapper">
                <p className="ctitle">可推荐课程</p>
                <p className="kc">{ info?.coursesInfo && info.coursesInfo.split(/\n/g).map(text => <span>{ text }</span>) }</p>
                <p className="ctitle">推荐学员</p>

                <div className="border-color" style={{  marginTop: '.5rem' }}>
                    <div className="lists">
                        {
                            lists.map((item,index) => {
                                return <div key={index} className={ classnames("iitem",{ active:item.detail }) } onClick={
                                    () => handleClick(item.id,index)
                                }>
                                    <div className="f">
                                        <p className="name">姓名：{ item.targetName }</p>
                                        <p className="s">查看推荐进度</p>
                                    </div>
                                    {
                                        item.detail && <div className="_detail">
                                            <p className="n">跟进记录：{ item.detail.length ===0 && '无' }</p>
                                            {
                                                item.detail.length > 0 && <ul>
                                                    {
                                                        item.detail.map((im,i) => {
                                                            return <li key={i}>
                                                                {
                                                                    dateFormat(im.createTime,undefined,undefined,true) + ' ' +
                                                                    getStatusCodeText(im.statusCode)
                                                                }
                                                            </li>
                                                        })
                                                    }
                                                </ul>
                                            }
                                        </div>
                                    }
                                </div>
                            })
                        }
                        <Pagination length={ lists.length } ref={pageRef}  onChange={ (n) => setPage(n) }/>
                    </div>
                </div>
            </div>
            <img src={ btn } alt="" className="btnbtn" onClick={() => push('/home/distribution/detail')}/>
        </div>

        {
            cover &&  <div className="rules-cover">
                <div className="_box">
                    <p className="ctitle">活动规则</p>
                    <div className="content">
                        <div dangerouslySetInnerHTML={{ __html: info ? info.ruleContent : '' }}/>
                    </div>
                    <p className="iconfont" onClick={handleCancel}>&#xe611;</p>
                </div>
            </div>
        }

    </div>
}

export default DistributionLists
